export default __webpack_public_path__ + "static/media/what-i've-done.beca507e.jpg";